import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './redux/store'; // Adjust path if your store is elsewhere
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { HelmetProvider } from 'react-helmet-async';

let persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HelmetProvider>
);

reportWebVitals();
